import { create } from 'zustand';
import { createJSONStorage, devtools, persist } from 'zustand/middleware';
import { SimpleBrandEntity, SimpleLocationEntity } from '../types';

type LocationBrandPickerStore = {
  selectedLocation: SimpleLocationEntity | null;
  setSelectedLocation: (value: SimpleLocationEntity | null) => void;
  selectedBrand: SimpleBrandEntity | null;
  setSelectedBrand: (value: SimpleBrandEntity | null) => void;
};

export const useLocationBrandPicker = create<LocationBrandPickerStore>()(
  devtools(
    persist(
      (set) => ({
        selectedLocation: null,
        setSelectedLocation: (value) =>
          set(() => ({ selectedLocation: value })),
        selectedBrand: null,
        setSelectedBrand: (value) => set(() => ({ selectedBrand: value })),
      }),
      {
        name: 'location-brand-picker',
        storage: createJSONStorage(() => localStorage),
        version: 1,
      }
    ),
    { name: 'locationBrandPicker' }
  )
);
